export default __webpack_public_path__ + "static/media/Piano.364de8e3.jpg";